const recursiveWalk = (obj, callback) => {
  if (obj && typeof obj === 'object') {
    Object.entries(obj).forEach(([key, value]) => {
      if (typeof value === 'string') {
        callback(obj, key, value);
      } else if (typeof value === 'object' && value !== null) {
        recursiveWalk(value, callback);
      }
    });
  }
};

export default recursiveWalk;
